import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../AuthContext';
import { useNavigate, NavLink } from 'react-router-dom';

export default function Leftbar() {
  const { authState, loading, logout } = useContext(AuthContext);
  const [isMenuEnabled, setIsMenuEnabled] = useState(false);
  const [isAihEnabled, setIsAihEnabled] = useState(false);
  const [isWayfinderEnabled, setIsWayfinderEnabled] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
    setShowLogoutConfirm(false);
  };

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  useEffect(() => {
    if (authState.featureAccess != null) {
      setIsMenuEnabled(authState?.featureAccess?.menuQuizEnabled);
      setIsAihEnabled(authState?.featureAccess?.aihEnabled);
      setIsWayfinderEnabled(authState?.featureAccess?.wayfinderEnabled);
    }
  }, [authState]);

  return (
    <div className="left-side-bar">
      <div className="brand-logo">
        <a href="/backend">AI Human</a>
        <div className="close-sidebar" data-toggle="left-sidebar-close">
          <i className="ion-close-round"></i>
        </div>
      </div>
      <div className="menu-block customscroll">
        <div className="sidebar-menu">
          <ul id="accordion-menu">
            {/* Admin menu */}
            {authState.token && authState.user.role === 1 && (
              <>
                <li>
                  <NavLink
                    to="/add-client"
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-person-plus"></span>
                    <span className="mtext">Add Client</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/view-clients"
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-people"></span>
                    <span className="mtext">View Clients</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/view-client-logs"
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-journal-text"></span>
                    <span className="mtext">View Logs</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/view-py-logs"
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-file-code"></span>
                    <span className="mtext">View Python Logs</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/view-button-logs/${authState.user._id}`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-graph-up"></span>
                    <span className="mtext">Interaction Report</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/questions-bank/${authState.user._id}`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-chat-dots"></span>
                    <span className="mtext">Question Pool</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/admin/global-settings`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-gear"></span>
                    <span className="mtext">Settings</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/admin/assets-report`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-folder"></span>
                    <span className="mtext">Assets Report</span>
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink
                    to={`/admin/video-management`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-camera-video"></span>
                    <span className="mtext">Video Management</span>
                    <span className="badge badge-success ml-2" style={{fontSize: '10px', padding: '2px 6px'}}>NEW</span>
                  </NavLink>
                </li> */}

                <li>
                  <NavLink
                    to={`/admin/video-generation-status`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-camera-reels"></span>
                    <span className="mtext">Video Status Monitor</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to={`/qr-scan-logs/${authState.user._id}`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-qr-code-scan"></span>
                    <span className="mtext">QR Scan Logs</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to={`/billing-track/${authState.user._id}`}
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-credit-card"></span>
                    <span className="mtext">Billing Tracker</span>
                  </NavLink>
                </li>

                {/* Wayfinder for Admin */}
                <li>
                  <NavLink
                    to="/admin/wayfinder-management"
                    className={({ isActive }) =>
                      `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                    }
                  >
                    <span className="micon bi bi-map"></span>
                    <span className="mtext">Wayfinder</span>
                  </NavLink>
                </li>
              </>
            )}

            {/* Client menu */}
            {authState.token && authState.user.role === 2 && (
              <>
                {isAihEnabled && (
                  <>
                    {/* <li>
                      <NavLink
                        to={`/view-avatar-settings/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${
                            isActive ? "active-tab" : ""
                          }`
                        }
                      >
                        <span className="micon bi bi-robot"></span>
                        <span className="mtext">Ai Human</span>
                      </NavLink>
                    </li> */}

                    <li>
                      <NavLink
                        to={`/view-avatar-settings/${authState.user._id}`}
                        onClick={e => {
                          e.preventDefault(); // stop React Router from handling navigation
                          window.location.href = `/view-avatar-settings/${authState.user._id}`; // full reload
                        }}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-robot"></span>
                        <span className="mtext">Ai Human</span>
                      </NavLink>
                    </li>
                    <li>
                      <a
                        href={`/${authState.user.client_url}`}
                        className="dropdown-toggle no-arrow"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="micon bi bi-eye"></span>
                        <span className="mtext">View Frontend</span>
                      </a>
                    </li>
                  </>
                )}

                {/* Wayfinder for Client - Direct Link */}
                {isWayfinderEnabled && (
                  <li>
                    <NavLink
                      to={`/wayfinder/${authState.user._id}`}
                      className={({ isActive }) =>
                        `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                      }
                    >
                      <span className="micon bi bi-map"></span>
                      <span className="mtext">Wayfinder</span>
                    </NavLink>
                  </li>
                )}

                {isMenuEnabled && (
                  <>
                    <li>
                      <NavLink
                        to={`/view-button-settings/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-list"></span>
                        <span className="mtext">View Menu Settings</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={`/view-button-logs/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-bar-chart"></span>
                        <span className="mtext">Interaction Report</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={`/quiz-report/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-card-checklist"></span>
                        <span className="mtext">Quiz Report</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={`/qr-scan-logs/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-qr-code-scan"></span>
                        <span className="mtext">QR Scan Logs</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={`/trivia-quiz/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-puzzle"></span>
                        <span className="mtext">Quiz Settings</span>
                      </NavLink>
                    </li>
                  </>
                )}
              </>
            )}

            {/* New Link Added */}
            {authState.token && authState.user.role === 2 && (
              <>
                {(isAihEnabled || isMenuEnabled) && (
                  <>
                    {' '}
                    <li>
                      <NavLink
                        to={`/availablity-settings/${authState.user._id}`}
                        className={({ isActive }) =>
                          `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                        }
                      >
                        <span className="micon bi bi-gear"></span>
                        <span className="mtext">System Settings</span>
                      </NavLink>
                    </li>
                  </>
                )}{' '}
              </>
            )}

            {/* Profile */}
            <li>
              <NavLink
                to={`/view-profile/${authState.user._id}`}
                className={({ isActive }) =>
                  `dropdown-toggle no-arrow ${isActive ? 'active-tab' : ''}`
                }
              >
                <span className="micon bi bi-person"></span>
                <span className="mtext">Profile</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Logout section remains unchanged */}
      <div className="sidebar-footer">
        <div className="user-profile-section">
          <div className="user-avatar">
            <div className="avatar-circle">
              {authState.user?.company_name
                ? authState.user.company_name.charAt(0).toUpperCase()
                : 'U'}
            </div>
          </div>

          <div className="user-info">
            <div className="user-name" title={authState.user?.company_name || 'User'}>
              {authState.user?.company_name || 'User'}
            </div>
            <div className="user-role">{authState.user?.role === 1 ? 'Administrator' : 'User'}</div>
          </div>

          <div className="logout-actions">
            <a
              className="logout-btn"
              style={{ color: 'white' }}
              onClick={handleLogoutClick}
              title="Logout"
            >
              <i className="bi bi-box-arrow-right"></i>
              {/* <span className="logout-text">Logout</span> */}
            </a>
          </div>
        </div>

        {/* Logout Confirmation Popup - Positioned outside the user profile section */}
        {showLogoutConfirm && (
          <div className="logout-confirm-overlay">
            <div className="logout-confirm-card">
              <div className="confirm-icon">
                <i className="bi bi-question-circle"></i>
              </div>
              <div className="confirm-content">
                <h4>Ready to Leave?</h4>
                <p>Are you sure you want to log out?</p>
                <div className="confirm-buttons">
                  <div>
                    {' '}
                    <button className="confirm-btn confirm-no" onClick={handleCancelLogout}>
                      <i className="bi bi-x-lg"></i>
                      Cancel
                    </button>
                  </div>
                  <div>
                    {' '}
                    <button className="confirm-btn confirm-yes" onClick={handleLogout}>
                      <i className="bi bi-check-lg"></i>
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .active-tab {
          background: rgba(236, 240, 244, 0.19);
          border-radius: 10px;
          color: #fff !important;
        }
        .sidebar-footer {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 25px 15px;
          border-top: 1px solid rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(15px);
          z-index: 100;
        }

        .user-profile-section {
          display: flex;
          align-items: center;
          gap: 15px;
          position: relative;
          z-index: 101;
        }

        .avatar-circle {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 16px;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
          border: 2px solid rgba(255, 255, 255, 0.2);
        }

        .user-info {
          flex: 1;
          min-width: 0;
        }

        .user-name {
          color: #fff;
          font-weight: 700;
          font-size: 15px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .user-role {
          color: rgba(255, 255, 255, 0.8);
          font-size: 12px;
          text-transform: capitalize;
          font-weight: 500;
        }

        .logout-actions {
          display: flex;
          align-items: center;
        }

        .logout-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.9);
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 14px;
          font-weight: 600;
          backdrop-filter: blur(10px);
        }

        .logout-btn:hover {
          background: rgba(239, 68, 68, 0.2);
          color: #ff6b6b;
          border-color: rgba(239, 68, 68, 0.4);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
        }

        .logout-text {
          font-weight: 600;
        }

        /* Enhanced Logout Confirmation */
        .logout-confirm-overlay {
          position: absolute;
          bottom: calc(100% + 10px);
          right: 20px;
          left: 20px;
          z-index: 1000;
          animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .logout-confirm-card {
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          // background: rgba(20, 20, 20, 0.2);
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          animation: scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .confirm-icon {
          text-align: center;
          margin-bottom: 15px;
        }

        .confirm-icon i {
          font-size: 48px;
          color: #f59e0b;
          background: linear-gradient(135deg, #f59e0b, #d97706);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .confirm-content h4 {
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 8px;
          text-align: center;
        }

        .confirm-content p {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          text-align: center;
          margin-bottom: 20px;
          line-height: 1.4;
        }

        .confirm-buttons {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .confirm-btn {
          height: 35px !important;
          display: flex;
          align-items: center;
          gap: 6px;
          // padding: 18px 20px;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          justify-content: center;
        }

        .confirm-yes {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
        }

        .confirm-yes:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(239, 68, 68, 0.6);
          background: linear-gradient(135deg, #dc2626, #b91c1c);
        }

        .confirm-no {
          background: rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .confirm-no:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }

        /* Animations */
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .sidebar-footer {
            padding: 16px;
          }

          .logout-confirm-overlay {
            right: 10px;
            left: 10px;
          }

          .confirm-buttons {
            flex-direction: column;
          }

          .confirm-btn {
            min-width: auto;
          }
        }
      `}</style>
    </div>
  );
}
